"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureEnabled = exports.isEnvironmentBlockEnabled = void 0;
var FeatureEncoding_1 = require("./feature-encoding/FeatureEncoding");
Object.defineProperty(exports, "isEnvironmentBlockEnabled", { enumerable: true, get: function () { return FeatureEncoding_1.isEnvironmentBlockEnabled; } });
var FeatureEncoding_2 = require("./feature-encoding/FeatureEncoding");
Object.defineProperty(exports, "isFeatureEnabled", { enumerable: true, get: function () { return FeatureEncoding_2.isFeatureEnabled; } });
